import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=c326405a"
import script from "./contact.ts?vue&type=script&lang=js&external"
export * from "./contact.ts?vue&type=script&lang=js&external"
import style0 from "./contact.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports